// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type AssetsInfoResp } from '@shared/data-access/interfaces/api/ai/assets';
import { type MyIdeas } from '@shared/data-access/interfaces/common/my-ideas';
import { type SavedPortfolio } from '@shared/data-access/interfaces/redux/my-research-state';

export function buildDataIdeas(
  ideas: SavedPortfolio[],
  positions: AssetsInfoResp[],
) {
  const portfolios_saved: MyIdeas[] = [];

  ideas.forEach(idea => {
    const subrows: any[] = [];

    if (idea.holdings.length === 0) return;

    idea.holdings.forEach(position => {
      const result = positions.filter(obj => {
        return obj.ticker === position.ticker;
      });

      if (result.length === 0) return;

      const item = result[0];

      const assetClass =
        'market_cap' in item
          ? 'Stock'
          : 'nav' in item
          ? 'Mutual Fund'
          : 'aum' in item
          ? 'ETF'
          : '-';

      subrows.push({
        portfolio_id: idea.portfolio_id,
        portfolio: position, // Name Ticker
        benchmark: idea.benchmark,
        investment: 0,
        weight: position.weight,
        unrealized_capital_gains: position.unrealized_capital_gains,
        creation_date: idea.creation_date,
        columnName: result[0],
        asset_class: assetClass, //here there is position info: logo_url, name, ticker....
        subRows: undefined,
      });
    });

    if (subrows.length === 0) return;

    const assetType = subrows[0].asset_class;
    const isMultiAsset = !subrows.every(
      position => position.asset_class === assetType,
    );

    portfolios_saved.push({
      portfolio_id: idea.portfolio_id,
      portfolio: idea.portfolio,
      benchmark: idea.benchmark,
      investment: 0,
      weight: 1,
      creation_date: idea.creation_date,
      columnName: idea.portfolio,
      asset_class: isMultiAsset ? 'Multi-asset' : assetType,
      subRows: subrows,
      organizations: idea.organizations,
      owner: idea.owner,
    });
  });

  return portfolios_saved;
}
